// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root__6OuAH","list":"Navigation_list__pwf2f"};